require('./home');
require('./coupons');
require('./shops');
require('./categories');
require('./campaigns');
require('./authors');
